/**
 * Opción seleccionable del menú institución / sede en la pantalla.
 * El nombre se compone por ` nombreInstitucion  || nombreDependencia (sede)`
 */
export interface IInstitucionSedeOpcionTerminalFormSnp {
  claveInstitucion?: string;
  claveDependencia?: string;
  nombre?: string;
}

export class InstitucionSedeOpcionTerminalFormSnp implements IInstitucionSedeOpcionTerminalFormSnp {
  constructor(public claveInstitucion?: string, public claveDependencia?: string, public nombre?: string) {}
}

/**
 * Menú de instituciones con su sede en la pantalla.
 */
export interface IMenuInstitucionSedeOpcionTerminalFormSnp {
  value?: InstitucionSedeOpcionTerminalFormSnp;
  text?: string;
}

export class MenuInstitucionSedeOpcionTerminalFormSnp implements IMenuInstitucionSedeOpcionTerminalFormSnp {
  constructor(public value?: InstitucionSedeOpcionTerminalFormSnp, public text?: string) {}
}

/**
 * Opción seleccionable del menú opciones de titulación en la pantalla.
 */
export interface IOpciontitulacionSnp {
  id?: number;
  nombre?: string;
}

export class OpcionTitulacionSnp implements IOpciontitulacionSnp {
  constructor(public id?: number, public nombre?: string) {}
}

/**
 * Menú para mostrar las opciones de titulación en la pantalla
 */
export interface IMenuOpciontitulacionSnp {
  value?: OpcionTitulacionSnp;
  text?: string;
}

export class MenuOpcionTitulacionSnp implements IMenuOpciontitulacionSnp {
  constructor(public value?: OpcionTitulacionSnp, public text?: string) {}
}

/**
 * Objeto principal para el formulario de pantalla
 */
export interface IOpcionTerminalFormSnp {
  cveOpcionTerminal?: string;
  descripcionOpcionTerminal?: string;
  fechaAlta?: Date;
  fechaBaja?: Date;
  instituciones?: Array<InstitucionSedeOpcionTerminalFormSnp>;
}

export class OpcionTerminalFormSnp implements IOpcionTerminalFormSnp {
  constructor(
    public cveOpcionTerminal?: string,
    public descripcionOpcionTerminal?: string,
    public fechaAlta?: Date,
    public fechaBaja?: Date,
    public instituciones?: Array<InstitucionSedeOpcionTerminalFormSnp>
  ) {
    if (!instituciones) {
      this.instituciones = [];
    }
  }
}

/**
 * Objeto para guardar los datos de las sedes de una institución.
 * Tercer nivel.
 */
export interface ISedeOpcionTerminalSnp {
  claveSede?: string;
  claveDependencia?: string;
  nombreDependencia?: string;
  sede?: string;
}

export class SedeOpcionTerminalSnp implements ISedeOpcionTerminalSnp {
  constructor(public claveSede?: string, public claveDependencia?: string, public nombreDependencia?: string, public sede?: string) {}
}

/**
 * Objeto para guardar los datos de instituciones.
 * Segundo nivel.
 */
export interface IInstitucionOpcionTerminalSnp {
  claveInstitucion?: string;
  nombreInstitucion?: string;
  sedes?: Array<SedeOpcionTerminalSnp>;
}

export class InstitucionOpcionTerminalSnp implements IInstitucionOpcionTerminalSnp {
  constructor(public claveInstitucion?: string, public nombreInstitucion?: string, public sedes?: Array<SedeOpcionTerminalSnp>) {
    if (!sedes) {
      this.sedes = [];
    }
  }
}

/**
 * Objeto para guardar los datos de opciones terminales en la base.
 * Pirmer nivel.
 */
export interface IOpcionTerminalSnp {
  cveOpcionTerminal?: string;
  descripcionOpcionTerminal?: string;
  fechaAlta?: Date;
  fechaBaja?: Date;
  instituciones?: Array<InstitucionOpcionTerminalSnp>;
  opcionTitulacion?: OpcionTitulacionSnp;
}

export class OpcionTerminalSnp implements IOpcionTerminalSnp {
  constructor(
    public cveOpcionTerminal?: string,
    public descripcionOpcionTerminal?: string,
    public fechaAlta?: Date,
    public fechaBaja?: Date,
    public instituciones?: Array<InstitucionOpcionTerminalSnp>,
    public opcionTitulacion?: OpcionTitulacionSnp
  ) {
    if (!instituciones) {
      this.instituciones = [];
    }
    if (!opcionTitulacion) {
      this.opcionTitulacion = null;
    }
  }
}
